export default "__VITE_ASSET__CM9q52uL__"